/* eslint-disable react/require-default-props */
import React from 'react';
import { BiddingData } from 'store/modules/bidding_store/types';
import { BulletinBiddingsTypes } from 'store/modules/bulletins_store/types';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { PanelState } from 'store/modules/panel_store/types';
import { buildRobotProposalParams } from 'services/robot_proposal_params';
import { Container } from './styles';

interface RobotButtonProps {
  bidding: BiddingData | BulletinBiddingsTypes;
  newLaw: boolean;
  setModalRobotWarningOpened: React.Dispatch<React.SetStateAction<boolean>>;
}

const RobotCreateProposalButton = (props: RobotButtonProps) => {
  const { newLaw, setModalRobotWarningOpened, bidding } = props;
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);

  const allowedPortals = panel.beebeeate_portals.map((portal) => portal.source_id);

  const createProposal = () => {
    if (newLaw) {
      setModalRobotWarningOpened(true);
    } else {
      window.location.href = `/facilitadores/robo?${buildRobotProposalParams(
        bidding,
      )}&routerType=showFilterProposalPage`;
    }
  };

  if (!allowedPortals.includes(bidding.electronic_trading.source_id)) return <div />;

  return (
    <Container
      className="d-inline-block mr-1 mb-1 position-relative databalloon"
      aria-label="Nova ferramenta de cadastro de proposta para uso no Robô de Lance Inteligente"
      data-balloon-pos="down"
      data-balloon-length="medium"
    >
      <button
        type="button"
        onClick={() => createProposal()}
        className="btn btn-sm btn-primary mt-1 mt-md-0"
      >
        Cadastrar Proposta
        <span className="badge badge-pill badge-danger position-absolute position-badge">NOVO</span>
      </button>
    </Container>
  );
};

export default RobotCreateProposalButton;
